
import Vue from 'vue'

export default Vue.extend({
  name: 'ImageLink',

  props: {
    image: {
      type: String as Prop<string>,
      required: true
    },
    width: {
      type: String as Prop<string>,
      default: '100%'
    },
    height: {
      type: String as Prop<string>,
      default: '100%'
    }
  },

  computed: {
    imageSrc (): string {
      return require(`../../assets/images/${this.image}`)
    }
  }
})
